import superagent from 'superagent';
import legacyIESupport from 'superagent-legacyiesupport';
import qs from 'qs';

const requestCache = {};

const defaultHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

const getCSRFToken = () => {
  const tokenMeta = document.querySelector('meta[name="csrf-token"]');
  return tokenMeta ? tokenMeta.content : ''; // TODO: csrf token is not present in specs
};

const methodHasContent = (method) => {
  return method === 'POST' || method === 'PUT';
};

export function request({
  url,
  method,
  headers = {},
  data = {},
  query = {},
  abortTag,
  timeout,
  includeAuthToken = true,
  protectCSRF = false,
}) {
  let authToken = null;
  try { authToken = window.Raise.data.authenticity_token; } catch (e) {}; // eslint-disable-line
  const authTokenHeaders = includeAuthToken && authToken ? { 'X-Auth-Token': authToken } : {};
  const additionalJsonHeaders = methodHasContent(method) && defaultHeaders['Content-Type'] === 'application/json' ? { Accept: 'application/json' } : {}; // eslint-disable-line
  const finalHeaders = {
    ...defaultHeaders,
    ...additionalJsonHeaders,
    ...headers,
    ...authTokenHeaders,
  };

  return new Promise((resolve, reject) => {
    let req = superagent(method, url);

    if (abortTag) {
      const previousRequest = requestCache[abortTag];
      if (previousRequest) previousRequest.abort();
      requestCache[abortTag] = req;
    }

    if (typeof timeout === 'number') {
      req = req.timeout(timeout);
    }

    let finalData = data;
    if (finalHeaders['Content-Type'] === 'application/x-www-form-urlencoded') {
      finalData = qs.stringify(data, { encode: false });
    }

    if (protectCSRF) {
      finalHeaders['X-CSRF-Token'] = getCSRFToken();
    }

    req
      .set(finalHeaders)
      .use(legacyIESupport)
      .send(finalData)
      .query(query)
      .end((error, response) => {
        if (abortTag) {
          delete requestCache[abortTag];
        }

        if (error) {
          reject(error);
        } else {
          resolve(response.body);
        }
      });
  });
}
